import Cabecera from "./Cabecera"
import TablaDocumentos from "./TablaDocumentos"
import TablaItems from "./TablaItems"
import { useSelector, useDispatch } from "react-redux"
import { useEffect } from "react"
import {obtenerComprasItemPaquete, obtenerVouchersDocumentoPaquete} from "./../../../../ducks/viajeCalendarioDuck"
const Items = () => {
    const {cliente} = useSelector(store => store.calendario)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerComprasItemPaquete({IdPaquete: cliente.paquete?.Id_Paquete }))
        dispatch(obtenerVouchersDocumentoPaquete({idPaquete: cliente.paquete?.Id_Paquete}))
    }, [dispatch, cliente.paquete?.Id_Paquete ])
    return (
        <div>
            <h4>Items</h4>
            <Cabecera />
            <TablaItems />
            <h4>Documentos Administrativos</h4>
            <TablaDocumentos />
        </div>
    )
}
export default Items